import React from 'react';
import useEntity from '@/lib/hooks/swr/useEntity';
import { useCurrentUser } from '@/lib/hooks/userData';
import type { FileUploadItem } from '@/modules/FileUploader';

type EntityData = {
  ownerOrgId: string;
  [key: string]: unknown;
};

const useEntityAttachments = ({
  entityId,
  entityType,
}: {
  entityId: string;
  entityType: string;
}) => {
  const { user = {} } = useCurrentUser();
  const { data, mutate } = useEntity(entityId, entityType);

  const handleUpload = React.useCallback(
    (e: FileUploadItem[]) => {
      if (!data) return;
      const attachments = e.map(({ uploadId }) => uploadId);
      const { displayName, userId } = user;
      const update = {
        attachments,
        ownerOrgId: (data as EntityData).ownerOrgId,
        updatedBy: { displayName, userId },
      };
      mutate(update);
    },
    [data, entityType, mutate, user],
  );

  return { handleUpload };
};

export default useEntityAttachments;
